<template>

<core-modal v-on:close="onClose" :icon="(!isEditing) ? false : 'caret-left'">

	<template v-slot:head>

		<template v-if="!isEditing">Create Index</template>
		<template v-if="isEditing">Edit Index</template>

	</template>

	<template v-slot:default>

		<div class="message" v-if="atLimit">
        
            You have hit your limit of {{ limit - 1 }} additional indexes on your insights.<br/>
            <br/>You must remove an index to add a new one.

		</div>

		<template v-if="!atLimit">

			<core-form-input-textbox :autofocus="true" maxlength="16" name="text" placeholder="Enter name" v-model="model.name" notes="Maximum of 16 characters." />

			<core-form-input-textarea maxlength="255" name="text" placeholder="Enter description" v-model="model.description" notes="Maximum of 255 characters. Describe what the index is tracking." />

			<core-form-input-togglelist class="create-toggle" v-model="model.public" :options="(hasPrivateFilters) ? publicOptionsLimited : publicOptions" />

			<div class="create-filters" v-on:click="onFiltersClick">

				<div class="create-filters-title">Filters</div>

				<div class="create-filters-text" v-if="!activeFilters">You have no selected any filters for your index.</div>
				
				<div class="create-filters-text" v-if="activeFilters">You have <b>{{ activeFilters }}</b> filter<template v-if="activeFilters > 1">s</template> selected.</div>
				
				<i class="fa fa-chevron-right create-filters-icon" />

			</div>

		</template>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!isValid" v-if="!isEditing">Create</core-button>
		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!isValid" v-if="isEditing">Save changes</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'
import Vue from 'vue'

export default {

	props: ['data'],

	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			model: {
				name: '',
				description: '',
				public: 0,
				filter: {
					expansions: 0,
					source: {
						plays: true
					},
					status: {
						own: 0
					}
				}
			},

			validation: {},
			
			publicOptions: [
				{ value: 0, title: 'Own Profile', text: 'The index is only shown on your profile and cannot be used by other users.'},
				{ value: 1, title: 'Share with Community', text: 'The index will also be made available for other users to add to their insights and generate peer metrics.'}
			],
			
			publicOptionsLimited: [
				{ value: 0, title: 'Own Profile', text: 'The index is only shown on your profile and cannot be used by other users.'},
			]

		}

	},

	created: function() {

		if (this.data.model) {

			Vue.set(this, 'model', this.$util.copy(this.data.model || this.model))

		} else if(this.data.index) {

			Vue.set(this, 'model', {
				name: this.data.index.name,
				description: this.data.index.description,
				public: this.data.index.public,
				filter: this.data.index.filter
			})
		
		}

		this.$store.commit('filter/hindex/set', this.model.filter)

	},

	computed: {

		isEditing: function() {

			return this.data.index

		},

		activeFilterName: function() {

			return this.$store.getters['filter/hindex/active']

		},

		hasPrivateFilters: function() {

			return this.activeFilterName.tags || this.activeFilterName['play.locations'] || this.activeFilterName['play.nolocation'] || this.activeFilterName['play.players.required'] || this.activeFilterName['play.players.together']

		},

		isValid: function() {

			return this.model.name && this.model.description && this.activeFilters > 0

		},

		activeFilters: function() {

			return this.$store.getters['filter/hindex/active/count']

		},

        isUpgraded: function() {

			return this.$store.getters['session/upgraded']

		},

		atLimit: function() {

            return this.remaining <= 0

        },

        limit: function() {

            return this.$store.getters['session/user'].hindex.limit

        },

        remaining: function() {

            return this.$store.getters['session/user'].hindex.remaining

        }

	},

	methods: {

		onFiltersClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'hindexFilter',
				model: this.$util.copy(this.model),
				index: this.data.index
			})

		},

		onConfirmClick: function() {

			if (this.isValid) {

				this.is.loading = true

				this.$api[(this.isEditing) ? 'put' : 'post']((this.isEditing) ? 'hindex/' + this.data.index.id : 'hindex/create', this.model).then(function(response) {

					if (!this.isEditing) {

						this.$routerPush({
							name: 'InsightsHindexIndex',
							params: {
								index: response.index.slug
							}
						})

					} 
						
					this.$store.commit('page/insights/hindex/indexes/index', response.index)
					this.$store.commit('page/insights/hindex/indexes/tracking', response.tracking)
					this.$store.commit('session/user/hindex', response.hindex)
					this.$store.commit('context/hindex', response.hindex)

					if (this.isEditing) {

						this.data.index = response.index

						this.$pubsub.$emit('insights.refresh')

					}

					this.onClose()

				}.bind(this))

			}

		},

		onClose: function() {

			this.$emit('close')

			if (this.isEditing) {

				this.$pubsub.$emit('open.modal', {
					id: 'hindexView',
					index: this.data.index,
					direct: true
				})

			}

		}

	}

}

</script>

<style scoped>

.message {
    font-size: 16px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    font-weight: 400;
    background-color: #254b5f;
    border-radius: 10px;
    padding: 20px;
    margin: 20px 20px;
}

.create-filters {
	padding: 20px 64px 20px 20px;
	border-radius: 10px;
	background-color: rgba(0, 0, 0, 0.1);
	color: #fff;
	cursor: pointer;
	user-select: none;
}

.is-desktop .create-filters:hover {
	background-color: rgba(0, 0, 0, 0.2);
}

.create-filters-title {
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 4px;
}

.create-filters-text {
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
}

.create-filters-icon {
	position: absolute;
	right: 20px;
	top: 50%;
	margin-top: -10px;
	opacity: 0.8;
	font-size: 20px;
}

.create-toggle {
	margin-top: 30px;
}

</style>